(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_f8091e8"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.ai-blog-posts-controls').forEach(function (controls) {
    var wrapper = controls.closest('[class*="ai-blog-posts-container"]');
    if (!wrapper) return;

    var list = wrapper.querySelector('.ai-blog-posts-list');
    var emptyMessage = wrapper.querySelector('.ai-blog-posts-empty-message');
    if (!list) return;

    var items = Array.prototype.slice.call(list.querySelectorAll('.ai-blog-post-item'));

    function apply() {
      var yearSel = controls.querySelector('[data-role="filter-year"]');
      var tagSel = controls.querySelector('[data-role="filter-tag"]');
      var sortSel = controls.querySelector('[data-role="sort"]');

      var year = yearSel ? yearSel.value : '';
      var tag = tagSel ? tagSel.value : '';
      var sortMode = sortSel ? sortSel.value : 'newest';

      var visibleCount = 0;

      items.forEach(function (item) {
        var matchesYear = !year || item.getAttribute('data-year') === year;
        var matchesTag = !tag || (item.getAttribute('data-tags') || '').split('|').indexOf(tag) !== -1;
        var visible = matchesYear && matchesTag;

        item.style.display = visible ? '' : 'none';
        if (visible) visibleCount++;

        var ts = parseInt(item.getAttribute('data-timestamp'), 10) || 0;
        var comments = parseInt(item.getAttribute('data-comments'), 10) || 0;

        if (sortMode === 'oldest') {
          item.style.order = ts;
        } else if (sortMode === 'commented') {
          item.style.order = -comments;
        } else {
          item.style.order = -ts;
        }
      });

      if (emptyMessage) {
        emptyMessage.style.display = visibleCount === 0 ? 'block' : 'none';
      }
    }

    controls.addEventListener('change', apply);
    apply();
  });
  } catch(e) { console.error(e); }
})();

})();
